import React from "react";

export default function UserPicture(props) {
  return (
    <img
      src={
        props.uid
          ? process.env.REACT_APP_PHOTO_FILE_URL + `%2F${props.uid}?alt=media`
          : "/images/profilePicture.png"
      }
      onError={(e) => {
        if (!e.target.src.endsWith("/images/profilePicture.png")) {
          e.target.src = "/images/profilePicture.png";
        }
      }}
      alt="User Profile Picture"
      className={props.imageSize}
      id="imageOnProfile"
    />
  );
}
